export default {"src":"/_next/static/media/logo.0caa7758.svg","height":180,"width":321,"blurWidth":0,"blurHeight":0};